import {Injectable} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {ApiResponse, ToastType} from '@shared/model';
import {ToasterService} from '@shared/service/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(public httpClient: HttpClient, public toaster: ToasterService) {
  }

  public errorHandler(_: { error: { message: any; }; status: any; message: any; }): Observable<ApiResponse> {
    return of({result: false, data: null, code: 'api.fatal-error', success: false});
  }

  public get(url: string): Observable<any> {
    return this.httpClient.get(url).pipe(
      catchError((error: { error: { message: any; }; status: any; message: any; }) => {
        return this.errorHandler(error);
      })
    );
  }

  public post(url: string, data: any, showToaster = false): Observable<any> {
    return this.httpClient.post(url, data).pipe(
      tap((data: any) => {
        if (showToaster) {
          this.toaster.showFromApiResponse(data as ApiResponse);
        }
      }),
      catchError((error: { error: { message: any; }; status: any; message: any; }) => {
        if (showToaster) {
          this.toaster.display({type: ToastType.ERROR, body: error.status == 400 ? 'api.error-400' : 'api.error-404'});
        } else {
          throw error;
        }

        return this.errorHandler(error);
      })
    );
  }

  public put(url: string, data: any, showToaster = false): Observable<any> {
    return this.httpClient.put(url, data).pipe(
      tap((data: any) => {
        if (showToaster) {
          this.toaster.showFromApiResponse(data as ApiResponse);
        }
      }),
      catchError((error: { error: { message: any; }; status: any; message: any; }) => {
        if (showToaster) {
          this.toaster.display({type: ToastType.ERROR, body: error.status == 400 ? 'api.error-400' : 'api.error-404'});
        }
        return this.errorHandler(error);
      })
    );
  }

  public patch(url: string, data: any, showToaster = false): Observable<any> {
    return this.httpClient.patch(url, data).pipe(
      tap((data: any) => {
        if (showToaster) {
          this.toaster.showFromApiResponse(data as ApiResponse);
        }
      }),
      catchError((error: { error: { message: any; }; status: any; message: any; }) => {
        if (showToaster) {
          this.toaster.display({type: ToastType.ERROR, body: error.status == 400 ? 'api.error-400' : 'api.error-404'});
        }

        return this.errorHandler(error);
      })
    );
  }

  public delete(url: string, showToaster = false): Observable<any> {
    return this.httpClient.delete(url).pipe(
      tap((data: any) => {
        if (showToaster) {
          this.toaster.showFromApiResponse(data as ApiResponse);
        }
      }),
      catchError((error: { error: { message: any; }; status: any; message: any; }) => {
        if (showToaster) {
          this.toaster.display({type: ToastType.ERROR, body: error.status == 400 ? 'api.error-400' : 'api.error-404'});
        }
        return this.errorHandler(error);
      })
    );
  }
}
